import theme from '../../../lib/theme';
import { SelectInputProps } from './SelectInput';

const {
  corners,
  inputReset,
  scale,
  colors,
  font: {
    heights,
    spacings,
    families,

    ...font
  },
} = theme;

export default ({ status }: SelectInputProps) => ({
  container: {
    ...inputReset,

    backgroundColor: colors.white,
    outline: 'none',
    border: `1px solid ${status ? colors[status] : colors.grey}`,
    borderRadius: corners.m,
    fontFamily: families.primary,
    fontSize: font.l,
    color: colors.black,
    padding: `${scale.xxs} ${scale.xs}`,
    width: '100%',
    height: 50,

    '&:focus': {
      borderColor: colors.focus,
    },
  },
});
